import { HomeTitle } from ".";
import { Link } from "react-router-dom";
import TrackVisibility from "react-on-screen";

const ServiceCard = ({ isVisible, service, index, color }) => {
	const animation = isVisible
		? `animate-animated animate-fadeInUp delay-${
				index > 2 ? index - 2 : index
		  } opacity-100`
		: "opacity-0";
	return (
		<article
			className={`text-center w-full bg-secondary p-4 rounded ${animation}`}
		>
			<img
				src={service.icon}
				className={`rounded-full m-auto ${color} h-20 w-20 sm:h-40 sm:w-40 object-cover p-1`}
				alt="service preview"
			/>
			<h3 className="font-bold text-xl text-primary my-2 uppercase">
				{service.title}
			</h3>
		</article>
	);
};

const HomeServices = ({ langWords }) => {
	return (
		<section className="container">
			<div className="max-w-6xl m-auto bg-gray-50 p-4 transform -translate-y-28 rounded shadow">
				<HomeTitle title={langWords.ourServices} center />
				<div className="grid grid-cols-2 md:grid-cols-3 gap-4 place-items-center p-4">
					{langWords?.servicesList?.map((service, index) => (
						<TrackVisibility key={index} className="w-full" once>
							<ServiceCard
								service={service}
								index={index}
								color={`bg-${service.altColor}`}
							/>
						</TrackVisibility>
					))}
				</div>
				<Link
					to="/services"
					className="py-2 capitalize px-4 mx-auto mt-4 block w-max rounded bg-primary text-secondary cursor-pointer hover:bg-opacity-90 text-center"
				>
					{langWords.seeMore}{" "}
				</Link>
			</div>
		</section>
	);
};

export default HomeServices;
